import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-qr-code-dialog',
  templateUrl: './qr-code-dialog.component.html',
  styleUrls: ['./qr-code-dialog.component.scss']
})
export class QrCodeDialogComponent implements OnInit {

  public qrCodeValue: string;
  ngOnInit() {
    this.qrCodeValue = window.location.href;
  }
}
